import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
  },
  icon: {
    marginRight: "6px",
    display: "flex",
    alignItems: "center",
  },
  label: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});
